import type { membershipApi } from 'app/src/services/welfareportal'
import { formatDateDDMMYYYY } from 'app/src/shared/helpers'
import { Card } from 'primereact/card'
import { useTranslation } from 'react-i18next'

export function CampaignListItem(props: {
  campaign: membershipApi.UserMembership
  checked: boolean
  onSelectionChange: (value: membershipApi.UserMembership) => void
}) {
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.CampaignSelectionDialog' })
  return (
    <Card
      data-testid='CampaignListItem-Card'
      role='button'
      tabIndex={0}
      className={
        props.checked
          ? 'border-1 --focusOutlineColor mt-4 cursor-pointer bg-[var(--primary-100)] p-1 shadow-none'
          : 'mt-4 cursor-pointer bg-[#F5F7FA] p-1 shadow-none'
      }
      pt={{ body: { className: 'p-1 pl-2 pr-2' } }}
      onClick={() => props.onSelectionChange(props.campaign)}
      onKeyDown={(evt) => {
        if (evt.key == 'Enter') props.onSelectionChange(props.campaign)
      }}
    >
      <div className='grid grid-cols-12'>
        <div className='col-span-11'>
          <div className='font-semibold text-[var(--gray-neutral)]'>{props.campaign.campaignName}</div>
          <div className='text-sm text-[var(--gray-500)]'>
            {t('from')} {formatDateDDMMYYYY(new Date(props.campaign.campaignDateFrom))} {t('to')}{' '}
            {formatDateDDMMYYYY(new Date(props.campaign.campaignDateTo))}
          </div>
        </div>
        <div className='col-span-1 content-center'>
          {props.checked ? <i className='pi pi-check' style={{ fontSize: '1.2rem' }}></i> : <></>}
        </div>
      </div>
    </Card>
  )
}
